<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="copyright"><span epub:type="pagebreak" id="pageiv" title="iv">This project was funded in part by a grant from the U.S. Department of the Interior, National Park Service, Japanese American Confinement Sites Grant Program. The views and conclusions contained in this document are those of the authors and should not be interpreted as representing the opinions or policies of the U.S. government. Mention of trade names or commercial products does not constitute their endorsement by the U.S. government.</span></p>
<p class="copyright1">The publishers wish to thank The Blue Family Charitable Fund and The Kagawa Family Charitable Fund, as well as individual donors, for their generous support of this project.</p>
<p class="copyright1">© 2018 by Manzanar History Association</p>
<p class="copyright1">All rights reserved. No portion of this work may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying and recording, or by any information storage or retrieval system, without permission in writing from Heyday.</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data is available.</p>
<p class="copyright1">Cover photo by Stone Ishimaru. Courtesy of The Bancroft Library, University of California, Berkeley. © Tec Com Productions</p>
<p class="copyright1">The family of Ichisuke and Ume Fukuhara, originally from Santa Monica, California, left Manzanar War Relocation Center and temporarily resettled in Farmingdale, Long Island. Here they are posed with their new friends, the Olsen family, outside their house on the grounds of the Calderone Greenhouses. Standing (<em>left to right</em>) are son Willy, Ichisuke, daughter Tomiko, Ume, daughter-in-law Fujiko, and Henry Fukuhara, Fujiko’s husband, who is holding their younger daughter, Yoshino. Among those seated is their older daughter, Shizuko.</p>
<p class="copyright1">ISBN: 9781597144469</p>
<p class="copyright1">Book design by Rebecca LeGates</p>
<p class="copyright1">Orders, inquiries, and correspondence should be addressed to:</p>
<p class="copyrighta">Heyday</p>
<p class="copyrighta">P.O. Box 9145, Berkeley, CA 94709</p>
<p class="copyrighta">(510) 549-3564, Fax (510) 549-1889</p>
<p class="copyrighta"><a href="http://www.heydaybooks.com" target="_blank">www.heydaybooks.com</a></p>
<p class="copyrighta">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2df07566